import camelize from '@afosto/utils/string/camelize';

const getShippingMethodName = (intl, method) => {
  if (method?.provider === 'tenant') {
    return intl.formatMessage({
      id: `shippingMethodNames.${camelize(method?.id)}`,
      defaultMessage: method?.name,
      description: `Name for shipping method ${method?.id}`,
    });
  }

  return method?.name;
};

export default getShippingMethodName;
